import type { ButtonProps } from '@mui/material';
import { Button as MuiButton } from '@mui/material';
import type { ReactNode } from 'react';

export interface IconButtonProps extends Omit<ButtonProps, 'startIcon' | 'endIcon' | 'children'> {
  /** Icon to render in button */
  icon: ReactNode;
}

/** Component to render only icon in the standard button */
export const IconButton = ({ icon, ...props }: IconButtonProps) => (
  <MuiButton {...props} startIcon={icon} />
);
